import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Divider, Stack, TextField, Typography } from '@mui/material';

// Shown instead of the registration form when the operator has closed open
// signup (member_signup_mode === 'invite_only'). Members join through their
// company's invite link or code; anyone else books from the public pages and
// gets a guest account there.

const CODE_CHARS = /[^23456789ABCDEFGHJKMNPQRSTUVWXYZ]/g;

export default function InviteOnlySignupPanel({ slug, colour, onBack }) {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const clean = code.toUpperCase().replace(CODE_CHARS, '');

  const buttonSx = colour
    ? { py: 1.5, bgcolor: colour, '&:hover': { bgcolor: colour, filter: 'brightness(0.92)' } }
    : { py: 1.5 };

  return (
    <Stack spacing={2.5}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          Joining by invite
        </Typography>
        <Typography variant="body2" color="text.secondary">
          We could not find an account for you. Member accounts are created from your company&apos;s invite link. Paste
          the code from it below.
        </Typography>
      </Box>
      <TextField
        fullWidth
        label="Invite code"
        placeholder="XXXX-XXXX"
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase().slice(0, 12))}
        inputProps={{ autoCapitalize: 'characters', spellCheck: false }}
      />
      <Button
        fullWidth
        variant="contained"
        sx={buttonSx}
        disabled={clean.length !== 8}
        onClick={() => navigate(`/join/${clean}`)}
      >
        Continue
      </Button>
      {slug && (
        <>
          <Divider sx={{ typography: 'caption', color: 'text.secondary' }}>Not joining a company?</Divider>
          <Button fullWidth variant="outlined" color="inherit" onClick={() => navigate(`/meeting-rooms/${slug}`)}>
            Book a meeting room
          </Button>
        </>
      )}
      {onBack && (
        <Button fullWidth color="inherit" onClick={onBack}>
          Back to sign in
        </Button>
      )}
    </Stack>
  );
}

InviteOnlySignupPanel.propTypes = {
  slug: PropTypes.string,
  colour: PropTypes.string,
  onBack: PropTypes.func,
};
